// Generated by purs version 0.13.8
"use strict";
var Control_Bind = require("../Control.Bind/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Combinators = require("../Data.Argonaut.Decode.Combinators/index.js");
var Data_Either = require("../Data.Either/index.js");
var decodeAt = function (dictDecodeJson) {
    return function (key) {
        return Control_Bind.composeKleisliFlipped(Data_Either.bindEither)(function (v) {
            return Data_Argonaut_Decode_Combinators.getField(dictDecodeJson)(v)(key);
        })(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeJsonJson)));
    };
};
module.exports = {
    decodeAt: decodeAt
};
